import "../../styles/footer/footer.css";
import { Link } from 'react-router-dom';
import { LuInstagram, LuFacebook, LuExternalLink } from "react-icons/lu";


const CLUB_LINKS = [
  { to: "/club", label: "Le club" },
  { to: "/infoscription", label: "Informations" },
  { href: "https://www.blvb.fr/blvb/", label: "BLVB" },
  { to: "/beach", label: "Beach" },
  { to: "/events", label: "Actualités" },
  { to: "/partners", label: "Partenaires" },
];

const USEFUL_LINKS = [
  { href: "http://www.ffvb.org/", label: "FFVB" },
  { href: "https://my.ffvolley.org/home", label: "MyFFVB" },
  { href: "https://www.lnv.fr/accueil", label: "LNV" },
  { href: "https://www.cdvb64.com/", label: "CDVB64" },
  { href: "https://www.ffvbbeach.org/ffvbapp/weblic/acces_licences.php", label: "Gestion des licences" },
];


function Footer() {

  return (
    <footer className="footer">
      <div className="tricolor" aria-hidden="true"><span></span><span></span><span></span></div>

      <div className="footer_inner">
        <div className="footer_columns">
          {/* LE CLUB */}
          <div className="footer_col footer_col--brand">
            <img className="footer_logo" src="/images/logo_vblc_new.png" alt="Logo du VBLC" />
            <p>Club de volley-ball et de beach-volley<br />Saint-Jean-de-Luz &amp; Ciboure</p>
            <p className="footer_muted">9 avenue Bordaberry<br />64500 Saint-Jean-de-Luz</p>
          </div>

          {/* NAVIGATION DU SITE */}
          <div className="footer_col">
            <p className="footer_title">VBLC</p>
            <ul className="footer_list">
              {CLUB_LINKS.map((link) => (
                <li key={link.label}>
                  {/* "href" = lien vers un autre site (nouvel onglet), "to" = page du site */}
                  {link.href
                    ? <a href={link.href} className="footer_link" target="_blank" rel="noopener noreferrer">
                      {link.label}
                      <LuExternalLink aria-hidden="true" className="footer_external_icon" />
                      <span className="sr-only">(nouvel onglet)</span>
                    </a>
                    : <Link to={link.to} className="footer_link">{link.label}</Link>}
                </li>
              ))}
            </ul>
          </div>

          {/* LIENS VERS D'AUTRES SITES OFFICIELS DU VOLLEY-BALL */}
          <div className="footer_col">
            <p className="footer_title">Liens utiles</p>
            <ul className="footer_list">
              {USEFUL_LINKS.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="footer_link" target="_blank" rel="noreferrer">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* RÉSEAUX SOCIAUX ET CONTACT */}
          <div className="footer_col">
            <p className="footer_title">Suivez-nous</p>
            <div className="footer_social">
              <a className="footer_social_link" href="https://www.instagram.com/vblc_volleyball/?hl=fr" target="_blank" rel="noreferrer" aria-label="Instagram du VBLC">
                <LuInstagram aria-hidden="true" />
              </a>
              <a className="footer_social_link" href="https://www.facebook.com/vblc64/" target="_blank" rel="noreferrer" aria-label="Facebook du VBLC">
                <LuFacebook aria-hidden="true" />
              </a>
            </div>
            <Link to="/contact" className="btn footer_contact">Nous contacter</Link>
          </div>
        </div>

        {/* BAS DE PAGE */}
        <div className="footer_bottom">
          <p>© {new Date().getFullYear()} VBLC — Volley-Ball Luzien Cibourien</p>
          <ul className="footer_bottom_links">
            <li><Link to="/signIn" className="footer_link">Espace membres</Link></li>
            <li><a href="https://www.vblc.fr/dolivblc/" className="footer_link" target="_blank" rel="noreferrer">Dolibarr</a></li>
            <li>
              <a href="https://byjmn.fr" className="footer_link footer_credit" target="_blank" rel="noreferrer">
                Site créé par
                <img className="footer_credit_logo" src="/images/jmnfavicon.png" alt="byjmn" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  )
};

export default Footer
